var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 10C2 4.5 6.5 0 12 0s10 4.5 10 10c0 7.4-9.1 13.6-9.4 13.8-.2.1-.4.2-.6.2s-.4-.1-.6-.2C11.1 23.6 2 17.4 2 10m2 0c0 5.4 6.1 10.4 8 11.8 1.9-1.4 8-6.4 8-11.8 0-4.4-3.6-8-8-8s-8 3.6-8 8m8-4c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4m-2 4c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2",
  clipRule: "evenodd"
})));
export default SvgMapPin;